import React from 'react';
import classNames from 'classnames';
import { ThemeContext } from '../context/themeContext';
import image from '../images/Akshay.jpg';

const About = () => {
  const { theme } = React.useContext(ThemeContext);
  const isDarkTheme = theme === 'dark';
  return (
    <section
      className={classNames(
        'body-font',
        { 'text-gray-600': !isDarkTheme },
        { 'text-gray-400 bg-gray-900': isDarkTheme },
      )}
    >
      <div className="container px-5 py-4 mx-auto">
        <div className="flex flex-wrap justify-center">
          <div className="lg:w-1/3 lg:mb-0 mb-6 p-4">
            <div className="h-full text-center">
              <img
                alt="testimonial"
                className={classNames(
                  'author-image mb-8 object-cover object-center rounded-full inline-block border-2',
                  { 'border-gray-200 bg-gray-100': !isDarkTheme },
                  { 'border-gray-800 bg-gray-800 bg-opacity-10': isDarkTheme },
                )}
                src={image}
              />
              <p className="leading-relaxed">
                Experienced Software Engineer with a demonstrated history of working in the
                information technology and financial services industry. Frontend Developer who works
                on various Javascript Frameworks such as React JS, Angular JS, and many more.
              </p>
              <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-6 mb-4" />
              <h2
                className={classNames(
                  'font-medium title-font tracking-wider text-sm',
                  { 'text-gray-900': !isDarkTheme },
                  { 'text-white': isDarkTheme },
                )}
              >
                Akshay Bandivadekar
              </h2>
              <p
                className={classNames(
                  { 'text-gray-700': !isDarkTheme },
                  { 'text-gray-300': isDarkTheme },
                )}
              >
                UI Developer
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
